

























import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'
import useStore from '@/composables/use-store'
import Store from '@/classes/Store'
import { shuffle } from 'lodash'

/**
 * @description Mapping of suggestion page path to arrays of store IDs that purchased ads
 * @example
 * {
 *   "taipei-car-rental": [130, 155, 269],
 *   "new-taipei-car-rental": [3, 220, 494],
 *   "okinawa-car-rental": [516, 485, 345]
 * }
 */
type AdSuggestion = Record<string, number[]>;

// FIXME: 動態管理推薦店家列表
const AD_SUGGESTION_STORE_PATH_IDX_MAP: AdSuggestion = {
  'taichung-car-rental': [364, 505],
  'penghu-car-rental': [160, 284, 531],
  'kinmen-car-rental': [310, 418, 70],
  'taipei-car-rental': [155, 269],
  'new-taipei-car-rental': [3, 220, 294],
  'okinawa-car-rental': [516, 485, 405],
  'kaohsiung-car-rental': [487],
}

export default defineComponent({
  props: {
    cityName: {
      type: String,
      required: true,
    },
    /**
     * 推薦頁面城市 url path
     */
    suggestionCityPath: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { fetchStore } = useStore()

    const fetchStoreList = async () => {
      const storeIds =
        AD_SUGGESTION_STORE_PATH_IDX_MAP[props.suggestionCityPath] || []
      if (!storeIds.length) return []
      // 隨機打亂 storeIds
      const shuffledStoreIds = shuffle(storeIds)
      const storePromises = shuffledStoreIds.map(id =>
        fetchStore(id).catch(() => null)
      )
      return (await Promise.all(storePromises)).filter(
        store => store !== null
      ) as Store[]
    }

    const storeList = ref<Store[]>([])

    onMounted(() => {
      (async () => {
        storeList.value = await fetchStoreList()
      })()
    })

    return {
      storeList,
      getSuggestionAdImage: Store.getSuggestionAdImage,
    }
  },
})
